import { render, staticRenderFns } from "./LoginToken.vue?vue&type=template&id=6be0500c&scoped=true"
import script from "./LoginToken.vue?vue&type=script&lang=js"
export * from "./LoginToken.vue?vue&type=script&lang=js"
import style0 from "./LoginToken.vue?vue&type=style&index=0&id=6be0500c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0500c",
  null
  
)

export default component.exports